<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <Agenda></Agenda>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import Agenda from '../components/Agenda.vue';
export default {
    name: 'HomeView',
    components: {
        ColumnaIzquierda,
        Agenda,
    }
}
</script>